import axios from 'axios';
import { baseUrl } from '@/config';
import forEach from 'lodash/forEach';

export default {
  /**
   * [getThreadList 성능/운영 > 구성 > 로디드 클래스 리스트를 리턴한다.]
   * @author yelim
   */
  getLoadedClassList(params) {
    return axios.post(`${baseUrl}/config/get-loaded-class-list.do`, params);
  },
  /**
   * [getThreadList 성능/운영 > 구성 > 쓰레드 리스트를 리턴한다.]
   * @author yelim
   */
  getThreadList(params) {
    return axios.post(`${baseUrl}/config/get-thread-list.do`, params);
  },
  /**
   * [getSocketList 성능/운영 > 구성 > 소켓 리스트를 리턴한다.]
   * @author yelim
   */
  getSocketList(params) {
    return axios.post(`${baseUrl}/config/get-socket-list.do`, params);
  },
  /**
   * [getEnvList 성능/운영 > 구성 > 환경변수 리스트를 리턴한다.]
   * @author yelim
   */
  getEnvList(params) {
    return axios.post(`${baseUrl}/config/get-env-list.do`, params);
  },
  /**
   * [getHeapHistoryList 성능/운영 > 구성 > 힙 리스트를 리턴한다.]
   * @author yelim
   */
  getHeapHistoryList(params) {
    return axios.post(`${baseUrl}/config/get-heap-history-list.do`, params);
  },
  /**
   * [getDumpFileList 성능/운영 > 구성 > 스냅샷 > 파일덤프 리스트를 리턴한다.]
   * @author yelim
   */
  getDumpFileList(params) {
    return axios.post(`${baseUrl}/config/get-dump-file-list.do`, params);
  },
  /**
   * [getHeapDumpList 성능/운영 > 구성 > 스냅샷 > 힙덤프 리스트를 리턴한다.]
   * @author yelim
   */
  getHeapDumpList(params) {
    return axios.post(`${baseUrl}/config/get-heap-dump-list.do`, params);
  },
  /**
   * [executeActiveSvcDump [APM 성능/운영 > 구성 > 스냅샷] 액티브 서비스 리스트 덤프 수행]
   * @author yelim
   */
  executeActiveSvcDump(params) {
    return axios.post(`${baseUrl}/config/trigger-active-service-list.do`, params);
  },
  /**
   * [executeThreadListDump [APM 성능/운영 > 구성 > 스냅샷] 쓰레드 리스트 덤프 수행]
   * @author yelim
   */
  executeThreadListDump(params) {
    return axios.post(`${baseUrl}/config/trigger-thread-list.do`, params);
  },
  callThreadDump(params) {
    return axios.post(`${baseUrl}/config/call-thread-dump.do`, params);
  },
  /**
   * [executeThreadDump [APM 성능/운영 > 구성 > 스냅샷] 쓰레드 덤프 수행]
   * @author yelim
   */
  executeThreadDump(params) {
    return axios.post(`${baseUrl}/config/trigger-thread-dump.do`, params);
  },
  /**
   * [executeHeapDump [APM 성능/운영 > 구성 > 스냅샷] 힙 덤프 수행]
   * @author yelim
   */
  executeHeapDump(params) {
    return axios.post(`${baseUrl}/config/call-heap-dump.do`, params);
  },
  /**
   * [executeHeapDump [APM 성능/운영 > 구성 > 스냅샷] 힙 히스토그램 덤프 수행]
   * @author yelim
   */
  executeHeapHistoDump(params) {
    return axios.post(`${baseUrl}/config/trigger-heap-histo.do`, params);
  },
  /**
   * [downloadHeapDump [APM 성능/운영 > 구성 > 스냅샷] 힙 덤프 다운로드]
   * @author yelim
   */
  downloadHeapDump(params) {
    return axios.post(`${baseUrl}/config/download-heap-dump.do`, params);
  },
  /**
   * [downloadHeapDump [APM 성능/운영 > 구성 > 스냅샷] 힙 덤프 다운로드]
   * @author yelim
   */
  deleteHeapDump(params) {
    return axios.post(`${baseUrl}/config/delete-heap-dump.do`, params);
  },
  getDumpFileDetail(params) {
    return axios.post(`${baseUrl}/config/get-dump-file-detail.do`, params);
  },
  /**
   * [executeRedefineClasses 로디드 클래스 > 선택한 리스트를 재정의를 수행한다.]
   * @author yelim
   */
  executeRedefineClasses(params) {
    return axios.post(`${baseUrl}/config/execute-redefine-classes.do`, params);
  },
  getThreadDetail(params) {
    return axios.post(`${baseUrl}/config/get-thread-detail.do`, params);
  },
  getActiveServiceList(params) {
    return axios.post(`${baseUrl}/config/get-active-service-list.do`, params);
  },
  getClassDescription(params) {
    return axios.post(`${baseUrl}/config/get-class-description.do`, params);
  },
  executeThreadControl(params) {
    return axios.post(`${baseUrl}/config/execute-thread-control.do`, params);
  },
  checkClassJarDown(params) {
    return axios.post(`${baseUrl}/config/check-class-jar-down.do`, params);
  },
  downloadLoadedClassInfo(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/config/download-loaded-class-info.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', value);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  },
  getApmConfigInfoDeviceList(params) {
    return axios.post(`${baseUrl}/config/get-apm-config-info-device-list.do`, params);
  },
  getApmConfigInfoBasic(params) {
    return axios.post(`${baseUrl}/config/get-apm-config-info-basicstatus.do`, params);
  },
  executeSystemGC(params) {
    return axios.post(`${baseUrl}/config/execute-system-gc.do`, params);
  },
  executeResetCache(params) {
    return axios.post(`${baseUrl}/config/execute-reset-cache.do`, params);
  },
  updateApmObjConfig(params) {
    return axios.post(`${baseUrl}/config/update-apm-obj-config.do`, params);
  },
  /**
   * [getThreadInfoExcelName 쓰레드 정보를 엑셀 출력한다.]
   * @author yelim
   */
  getThreadInfoExcelName(params) {
    return axios.post(`${baseUrl}/config/get-thread-info-excel-name.do`, params);
  },
  /**
   * [getHeaphistoInfoExcelName 힙 정보를 엑셀 출력한다.]
   * @author yelim
   */
  getHeaphistoInfoExcelName(params) {
    return axios.post(`${baseUrl}/config/get-heaphisto-info-excel-name.do`, params);
  },
  /**
   * [getLoadedclassExcelName 로디드클래스 정보를 엑셀 출력한다.]
   * @author yelim
   */
  getLoadedclassExcelName(params) {
    return axios.post(`${baseUrl}/config/get-loadedclass-excel-name.do`, params);
  },
  /**
   * [getSocketExcelName 소켓 정보를 엑셀 출력한다.]
   * @author yelim
   */
  getSocketExcelName(params) {
    return axios.post(`${baseUrl}/config/get-socket-excel-name.do`, params);
  },
  /**
   * [getFileSnapshotExcelName 파일 스냅샷 정보를 엑셀 출력한다.]
   * @author yelim
   */
  getFileSnapshotExcelName(params) {
    return axios.post(`${baseUrl}/config/get-file-snapshot-excel-name.do`, params);
  },
  /**
   * [getHeapSnapshotExcelName 힙 스냅샷 정보를 엑셀 출력한다.]
   * @author yelim
   */
  getHeapSnapshotExcelName(params) {
    return axios.post(`${baseUrl}/config/get-heap-snapshot-excel-name.do`, params);
  },
  /**
   * [getEnvExcelName 환경변수 정보를 엑셀 출력한다.]
   * @author yelim
   */
  getEnvExcelName(params) {
    return axios.post(`${baseUrl}/config/get-env-excel-name.do`, params);
  },
  /**
   * [getActiveSvcExcelName 액티브 서비스 정보를 엑셀 출력한다.]
   * @author yelim
   */
  getActiveSvcExcelName(params) {
    return axios.post(`${baseUrl}/config/get-active-svc-excel-name.do`, params);
  },
  /**
   * [getApmDeviceExcelName APM 장비목록 엑셀 출력한다.]
   * @author yelim
   */
  getApmDeviceExcelName(params) {
    return axios.post(`${baseUrl}/config/get-apm-device-excel-name.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/config/apm/apm-info.js